import axios from "axios";
export const ServiceMiddleware = store => next => async action => {
  if (action === undefined || !action.serviceName) {
    if (action === undefined) action = { type: "" };
    next(action);
    return;
  }

  const { serviceName, method, onLoad, onSuccess, onFailure, formdata } = action;
  const { dispatch } = store;

  dispatch(onLoad);
  let response = {};
  try {
    if (method.toLowerCase() === "get") {
      response = await axios.get(serviceName);
    }
    else if (method.toLowerCase() === "post") {
      var myJSON = JSON.stringify(formdata);
      let data = new FormData();
      data.append('data', myJSON);
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };

      response = await axios.post(
        serviceName,
        data,
        config
      );
    }
    else if (method.toLowerCase() === "script") {
      response = { data: window.VisualizeROI };
    }
    let d = onSuccess(response.data);
    if (d instanceof Array)
      d.forEach(dd => {
        dispatch(dd);
      });
    else dispatch(d);
  }
  catch (error) {
    dispatch(onFailure(error));
  }
};
